var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.title,
        size: "medium",
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
        submitDisabled: _vm.selectedDriveId === "" || _vm.notEnoughFreeSpace,
      },
      on: { submit: _vm.goForward, cancel: _vm.handleClickCancel },
    },
    [
      _vm.notEnoughFreeSpace
        ? _c(
            "UiAlert",
            { attrs: { type: "error", dismissible: false, removeIcon: true } },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$tr("notEnoughFreeSpaceWarning")) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm.driveStatus === "ERROR"
        ? _c("UiAlert", { attrs: { type: "error", dismissible: false } }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$tr("problemFindingLocalDrives")) + "\n  "
            ),
          ])
        : _vm._e(),
      _c(
        "transition",
        { attrs: { mode: "out-in" } },
        [
          _vm.driveStatus === "LOADING"
            ? _c("UiAlert", { attrs: { type: "info", dismissible: false } }, [
                _c("span", { staticClass: "finding-local-drives" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tr("findingLocalDrives")) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.driveStatus === ""
            ? _c("DriveList", {
                attrs: { drives: _vm.enabledDrives, mode: _vm.driveListMode },
                model: {
                  value: _vm.selectedDriveId,
                  callback: function ($$v) {
                    _vm.selectedDriveId = $$v
                  },
                  expression: "selectedDriveId",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }